const tooltipImageModules = import.meta.glob<{ default: string }>(
  "../images/*.png",
  { eager: true }
);

export const getTooltipImageSrc = (imageFile: string) =>
  tooltipImageModules[`../images/${imageFile}.png`]?.default;
